import React from "react";

import { useGetRelatedNews, useTranslation, useUserContext } from "utils";

import { Col, IconLinkButton, NewsCard, Row } from "components";

export const RelatedNews = ({ link }) => {
  const { t } = useTranslation(["news"]);
  const { user } = useUserContext();

  const { news, newsIsLoading: loading } = useGetRelatedNews({ link });

  return (
    !loading &&
    news?.length && (
      <>
        <Row className="margin-top-450 margin-bottom-100">
          <Col>
            <IconLinkButton
              size="large"
              iconType="arrow"
              text={t("post.related")}
              mixpanelText={t("post.related")}
              href={user ? "/search/knowledge" : "/search"}
            />
          </Col>
        </Row>
        <Row>
          {/* prelint-ignore-col */}
          {news.map((newsArticle) => (
            <Col sm={24} md={8} key={newsArticle.id}>
              <NewsCard link={newsArticle.link} />
            </Col>
          ))}
        </Row>
      </>
    )
  );
};
